import web2app from '@zzng/common/lib/web2app';

import {
  ALL_SCHEME_REG,
  ANDROID_INTENT_PACKAGE,
  KAKAOTALK_APP_STORE_URL,
  SCHEME_PROTOCOL,
  SCHEME_REG,
  SchemeType,
  UNIVERSAL_LINK_BASE_URL
} from '../constants/scheme';
import {isAndroid, isIOS, isKakaoTalk} from './agent';
import {isDev} from './common';

export const determineProtocol = (condition = isIOS) => {
  // 개발 환경이 아니라면 condition과 무관하게 무조건 프로덕션 프로토콜을 반환
  if (!isDev) return SCHEME_PROTOCOL.PRODUCTION;
  return condition ? SCHEME_PROTOCOL.DEVELOPMENT : SCHEME_PROTOCOL.PRODUCTION;
};

export const getIntent = (scheme: string) => {
  const intentPackage = ANDROID_INTENT_PACKAGE[TARGET];
  const [, path] = scheme.split('://');

  return `intent://${path}#Intent;package=${intentPackage};scheme=kakaotalk;end;`;
};

export const executeAppSchemeIOS = (scheme: string) => {
  const universalBaseUrl = UNIVERSAL_LINK_BASE_URL[TARGET];
  const universalLink = `${universalBaseUrl}/scheme/${encodeURIComponent(scheme)}`;

  web2app({
    urlScheme: scheme,
    universalLink,
    onAppMissing: () => {}
  });
};

export const executeAppSchemeAndroid = (scheme: string) => {
  const intentURI = getIntent(scheme);

  web2app({
    urlScheme: scheme,
    intentURI,
    storeURL: KAKAOTALK_APP_STORE_URL.AOS
  });
};

export const executeAppScheme = (scheme: string, protocolCondition?: boolean) => {
  const protocol = determineProtocol(protocolCondition);
  const customScheme = scheme.replace(ALL_SCHEME_REG, protocol);

  if (isKakaoTalk) {
    window.open(customScheme, '_self');
    return;
  }

  if (isIOS) {
    executeAppSchemeIOS(customScheme);
    return;
  }

  executeAppSchemeAndroid(customScheme);
};

export const goKakaotalkAppStore = () => {
  window.location.href = isAndroid ? KAKAOTALK_APP_STORE_URL.AOS : KAKAOTALK_APP_STORE_URL.IOS;
};

export const isKakaotalkProtocol = (url: string) => {
  return /(kakao|alpha)[a-z]*:/g.test(url);
};

export const isTalkScheme = (url: string, schemeType: SchemeType) => {
  // 정규표현식을 재설정하여 이전 매치 결과의 영향을 받지 않도록 합니다.
  SCHEME_REG[schemeType].lastIndex = 0;
  return SCHEME_REG[schemeType].test(url);
};
